import { Container, Row, Col } from "react-bootstrap";
import logo from "../assets/img/website-logo's/image.png";
import navIcon1 from "../assets/img/nav-icon-linkedin.svg";
import navIcon2 from "../assets/img/resume-download-icon-2.svg";
import navIcon3 from "../assets/img/gitlab logo.png";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={4} xl={4}>
            <img src={logo} alt="Logo" className={styles.icon} />
          </Col>
          <Col xs={12} md={4} xl={4} className="footer-righ-column">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/henri-vandeputte-83ba45215/">
                <img src={navIcon1} alt="Icon" />
              </a>
              <a href="/assets/CV_Henri-Vandeputte-20260528.pdf">
                <img src={navIcon2} alt="Icon" />
              </a>
              <a href="https://github.com/HenriVandeputte">
                <img src={navIcon3} alt="Icon" />
              </a>
            </div>
          </Col>
          <Col xs={12} md={4} xl={4}>
            <p className={styles.text}> Powered by</p>
            <a
              href="https://vandeputte-software-development.com/"
              className={styles.link}
            >
              Vandeputte-Software-Development
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
export default Footer;
